export const stringToInt = ({ value }: { value: string }): number => Number.parseInt(value);
